export * from '@fhs/routing/src/routes/v2/[staticPage]/index';
export { default } from '@fhs/routing/src/routes/v2/[staticPage]/index';
